export default {
  methods: {
    reset () {
      if (typeof this.$refs.input !== 'undefined') {
        this.$refs.input.value = ''
        // Ensure rf-select is reset; this doesn't hurt if the input isn't a <select>...
        this.$refs.input.selectedIndex = -1
      }
      this.value = this.type === 'checkbox' ? [] : null
      this.isDirty = false
      this.clearValidation()
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/reset.js